var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAnalyticsReport = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.6 0.9)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.8 29 V22.6 L6.6 18.5 V29 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.0 29 V16.9 L11.8 12.8 V29 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2 29 V14.3 L17.0 18.4 V29 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4 29 V17.4 L22.2 13.6 V29 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6 29 V13.7 L27.4 9.9 V29 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.8 19.4 L11.8 9.6 L17.2 15.4 L27.1 6.1",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.4 2.8 L28.5 9.7 L23.6 4.7 Z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAnalyticsReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_analytics_report.c14741f9d0feae3a36373dace628226e.svg";